import { render } from "./StatusChipComponent.vue?vue&type=template&id=c85be29a&scoped=true"
import script from "./StatusChipComponent.vue?vue&type=script&lang=js"
export * from "./StatusChipComponent.vue?vue&type=script&lang=js"

import "./StatusChipComponent.vue?vue&type=style&index=0&id=c85be29a&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85be29a"]])

export default __exports__